import React from 'react'
import SearchField from '../../../shared/SearchField'
import { useTranslation } from 'react-i18next'

function CustomGeneralSearch ({
  searchQuery,
  setSearchQuery,
  payload,
  setPayload,
  fetchInitialData
}) {
  const { t } = useTranslation()
  
  return (
    <SearchField
      className='w-[180px]  mb-3'
      value={searchQuery || ''}
      onChange={e => {
        setSearchQuery(e.target.value)
        const updatedPayload = { ...payload, query: e.target.value, page: 1 }
        setPayload(updatedPayload)
      }}
      placeholder={t('SearchByName')}
    />
  )
}

export default CustomGeneralSearch
